import React, { useState } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"; // new library for zooming and panning
import { X } from "lucide-react";

import styles from "./MenuCard.module.css";

import bookOpenIcon from "@/ui/assets/icons/bookOpenIcon.svg";

import menu1 from "@/ui/assets/images/menu/menu1.jpg";
import menu2 from "@/ui/assets/images/menu/menu2.jpg";
import menu3 from "@/ui/assets/images/menu/menu3.jpg";

const menuImages = [menu1, menu2, menu3];

const MenuCard = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <>
            <article className={styles.menuCard}>
                <div className={styles.header}>
                    <div className={styles.iconContainer}>
                        <img
                            src={bookOpenIcon}
                            alt="Carta"
                            className={styles.icon}
                        />
                    </div>

                    <div className={styles.information}>
                        <h2 className={styles.title}>Carta completa</h2>

                        <p className={styles.description}>
                            Explora todos nuestros sabores
                        </p>
                    </div>
                </div>

                <div className={styles.images}>
                    {menuImages.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`Carta ${index + 1}`}
                            className={styles.image}
                            onClick={() => setSelectedImage(image)}
                        />
                    ))}
                </div>
            </article>

            {selectedImage && (
                <div
                    className={styles.modal}
                    onClick={() => setSelectedImage(null)}
                >
                    <div
                        className={styles.modalContent}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className={styles.closeButton}
                            onClick={() => setSelectedImage(null)}
                            aria-label="Cerrar imagen"
                        >
                            <X size={28} color="#A0551C" />
                        </button>

                        <TransformWrapper
                            initialScale={1}
                            minScale={1}
                            maxScale={4}
                            centerOnInit
                            limitToBounds={false}
                            smooth={true}
                            wheel={{
                                step: 0.04,
                            }}
                            pinch={{
                                step: 4,
                            }}
                            doubleClick={{
                                disabled: true,
                            }}
                            panning={{
                                velocityDisabled: true,
                            }}
                        >
                            <TransformComponent
                                wrapperClass={styles.transformWrapper}
                                contentClass={styles.transformContent}
                            >
                                <img
                                    src={selectedImage}
                                    alt="Carta ampliada"
                                    className={styles.modalImage}
                                    draggable={false}
                                />
                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}
        </>
    );
};

export default MenuCard;